import {
    HttpErrorResponse,
    HttpEvent,
    HttpHandler,
    HttpInterceptor,
    HttpRequest,
    HttpResponse
  } from '@angular/common/http';
  import { Injectable, isDevMode } from '@angular/core';
  import { Observable, catchError, finalize, tap, throwError } from 'rxjs';
  
  @Injectable()
  export class HttpLoggingInterceptor implements HttpInterceptor {
  
    constructor(

    ) {}
  
    intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
      const requestId = this.generateRequestId();
      const startTime = Date.now();
      let status: 'Success' | 'Error' = 'Success';
  
      return next.handle(request).pipe(
        tap((event) => {
          if (event instanceof HttpResponse) {
           
          }
        }),
        catchError((error: HttpErrorResponse) => {
          if (isDevMode()) {
            console.error('Error from HTTP Interceptor', error);
          }
          status = 'Error'
          return throwError(() => error);
        }),
        finalize(() => {
          const elapsedTime = Date.now() - startTime;
        })
      );
    }
  
    private generateRequestId(): string {
      return Math.random().toString(36).substring(2) + Date.now().toString(36);
    }
  }
  